module.exports = __webpack_public_path__ + "img/external.b0d604f2.svg";